import React, { FC, ChangeEvent } from 'react'
import { useDebouncedCallback } from 'use-debounce'

import Toggle, { ToggleProps } from 'src/Components/toggle/Toggle'

interface ActiveMessageSwitchProps extends ToggleProps {
  onChangeWithoutDebounce?: (isChecked: boolean) => void
}

/**
 * Switch element for the disabling/enabling of the messages
 */
const ActiveMessageSwitch: FC<ActiveMessageSwitchProps> = ({ onChange, onChangeWithoutDebounce, checked, ...props }) => {
  const debouncedOnChange = useDebouncedCallback((event: ChangeEvent<HTMLInputElement>, isChecked: boolean) => {
    onChange?.(event, isChecked)
  }, 500)

  const onChangeSwitch = (event: ChangeEvent<HTMLInputElement>, isChecked: boolean): void => {
    onChangeWithoutDebounce?.(isChecked)
    debouncedOnChange.callback(event, isChecked)
  }

  return <Toggle {...props} checked={checked} onChange={onChangeSwitch} />
}

export default ActiveMessageSwitch
